import { defineMessages } from 'react-intl-next';

export const messages: {
	dropdownMessage: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	seeAllLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	videoIconLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	videoThumbnailAltText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	videoThumbnailAltText: {
		id: 'dynamic-cards-search-page.video-search-result.video-thumbnail-alt-text',
		defaultMessage: 'Video thumbnail',
		description:
			'Video thumbnail alt text which is used for the alt text of the video thumbnail image in the video search results',
	},
	videoIconLabel: {
		id: 'dynamic-cards-search-page.video-search-result.video-icon-label',
		defaultMessage: 'video icon',
		description: 'Video icon label which is shown in front of the video duration',
	},
	dropdownMessage: {
		id: 'dynamic-cards-search-page.video-search-result.dropdown-message',
		defaultMessage:
			'{chapterCount, plural, one {# chapter in this video} other {# chapters in this video}}',
		description: 'Dropdown message for video search result',
	},
	seeAllLabel: {
		id: 'dynamic-cards-search-page.video-search-result.see-all-label',
		defaultMessage: 'See all',
		description:
			'Label for the link that allows users to see all chapters in a video when there are more than 10 chapters',
	},
});
